// src/hooks/usePaginationState.js
import { useSearchParams } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";

export function usePaginationState() {
  const [searchParams, setSearchParams] = useSearchParams();

  const getPaginationModel = () => ({
    page: parseInt(searchParams.get("page")) || 0,
    pageSize: parseInt(searchParams.get("pageSize")) || 10,
  });

  const setPaginationModel = (model) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set("page", model.page);
    newSearchParams.set("pageSize", model.pageSize);
    setSearchParams(newSearchParams);
  };

  return [getPaginationModel(), setPaginationModel];
}
